/* eslint-disable import/no-cycle */
import styled, { css } from 'styled-components'

import mediaQueries from 'components/media-queries'
import e2eClasses from 'helpers/automation'

export const InfoContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  flex-direction: row-reverse;
  position: absolute;
  z-index: 2;
  width: ${({ isLanding, isMultipleSlide }) => (!isLanding || isMultipleSlide) && '100%'};
  max-width: ${({ isLanding, isMultipleSlide }) => (!isLanding || isMultipleSlide) && '92vw'};
  color: ${({ theme }) => theme.colors.white};
  text-shadow: 0 2px 4px ${({ theme }) => theme.shadow.black50};

  ${mediaQueries.mobile`
    flex-direction: column;
    height: 60%
    
  ${mediaQueries.tablet`
    flex-direction: column;
    height: 60%
  `};
  `}
`

export const Info = styled.div`
  display: flex;
  flex-direction: column;
  margin: 74.5px;
  ${mediaQueries.mobile`
    margin: 40px 20px;
  `}
`

export const PauseBtnContainer = styled.div`
  width: 50px;
  margin-top: 32px;
  ${mediaQueries.mobile`
    position: relative;
    left: 90%;
    margin-top: 20px;
  `}
`

export const Image = styled.img`
  max-height: 640px;
  height: auto;
  width: 100%;
  background-image: linear-gradient(
      to right,
      ${({ theme }) => theme.colors.blue},
      ${({ theme }) => theme.colors.white}
    ),
    url(${({ src }) => src});
  object-position: center;
  object-fit: cover;
  z-index: ${({ hasImage }) => (hasImage ? '1' : '-1')};
`

export const ImageLink = styled.a.attrs(({ dataPosition, dataSection, dataDescription }) => ({
  className: e2eClasses('home.banner.box'),
  'data-posición': dataPosition,
  'data-section': dataSection,
  'data-description': dataDescription
}))`
  background-image: linear-gradient(
    to right,
    ${({ theme }) => theme.colors.blue},
    ${({ theme }) => theme.colors.white}
  );
  display: flex;
  z-index: 3;

  height: ${({ withSearchBox }) => (!withSearchBox ? '315px' : '640px')};
`

export const CarouselItem = styled.div.attrs(({ datainterval }) => ({
  ...(datainterval ? { 'data-interval': datainterval } : {})
}))``

export const Title = styled.h2.attrs(() => ({
  className: e2eClasses('home.banner.title')
}))`
  font-family: ${({ theme }) => theme.fonts.semiBold};
  font-size: 40px;
  ${mediaQueries.tablet`
    max-width: 100%;
  `};
  ${({ isDarkSiteEnabled }) =>
    isDarkSiteEnabled &&
    css`
      font-size: 37px;
      ${mediaQueries.mobile`
        font-size: 25px;
      `}
    `}
`

export const Subtitle = styled.h3.attrs(() => ({
  className: e2eClasses('home.banner.subtitle')
}))`
  font-family: ${({ theme }) => theme.fonts.semiBold};
  font-size: 24px;
`

export const Description = styled.div.attrs(() => ({
  className: e2eClasses('home.banner.description')
}))`
  font-family: ${({ theme }) => theme.fonts.regular};
  margin-bottom: 15px;
`

export const ButtonContainer = styled.div.attrs(() => ({
  className: e2eClasses('home.banner.button')
}))`
  width: 250px;
`

export const Wrapper = styled.div`
  width: 100%;

  .slick-dots {
    bottom: ${({ isLanding, withSearchBox }) => (isLanding && !withSearchBox ? '20px' : '235px')};
  }

  .slick-dots li button:before {
    font-size: 0;
    background: transparent;
    cursor: pointer;
    display: block;
    height: 13px;
    width: 13px;
    border-radius: 8px;
    border: 1px solid ${({ theme }) => theme.colors.white};
    box-shadow: 1px 1px 2px ${({ theme }) => theme.colors.black};
  }
  .slick-dots li.slick-active button:before {
    background: white;
  }
  .slick-slide a,
  .slick-slide button {
    visibility: hidden;
  }
  .slick-slide.slick-active a,
  .slick-slide.slick-active button,
  .slick-slide img {
    visibility: visible;
  }
`
export const Logo = styled.img`
  width: ${({ width }) => width || '180'}px !important;
  height: ${({ heigth }) => heigth || '120'}px;
  max-width: 220px;
  max-height: 160px;
`
